module.exports = __webpack_public_path__ + "img/D201709_1.83ec9fc2.jpg";